import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import getUsers, { getUserById } from "../getUsers";
import { queryKeys } from "../queryKeys";

export default function useUsers() {
  const { companyId } = useParams();
  const query = useQuery({
    queryKey: queryKeys.users(companyId),
    queryFn: () => getUsers(companyId),
  });
  return query;
}

export function useUserById(id: string) {
  const { companyId } = useParams();
  const query = useQuery({
    queryKey: queryKeys.userById(companyId!, id),
    queryFn: () => getUserById(id),
  });
  return query;
}
